import { createContext, useContext, useEffect, useState } from "react";
import { useSiteData } from "./SiteContext";
import { useLocation, useNavigate } from "react-router-dom";

export const AuthContext = createContext();

export const useAuthContext = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoggedin, setIsLoggedin] = useState(false);
  const { setIsLoading } = useSiteData();
  let navigate = useNavigate();
  let location = useLocation();
  // updating each value for every mounting
  useEffect(() => {
    setIsLoading(true);
    let newUser = JSON.parse(localStorage.getItem("user"));
    setUser(newUser);
    setIsLoggedin(newUser !== null || false);
    // setting admin status
    const status = newUser ? newUser.auth.isAdmin : false;
    setIsAdmin(status);
    setIsLoading(false);
  }, []);

  // self definded functions
  const logout = () => {
    console.log("authcontext");
    setIsLoading(true);
    setUser(null);
    localStorage.setItem("user", null);
    console.log("logout completed");
    setIsLoggedin(false);
    setIsLoading(false);
  };
  const login = (data) => {
    setIsLoading(true);
    localStorage.setItem("user", JSON.stringify(data));
    setUser(data);
    navigate(location.state ? location.state.from : "/dashboard");
    console.log("login completed");
    setIsLoggedin(true);
    setIsLoading(false);
  };
  const value = {
    // user datas
    user,
    setUser,

    // checkers
    isAdmin,
    setIsAdmin,
    isLoggedin,
    setIsLoggedin,

    // log out function
    logout,
    login,
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
